import { environment } from 'src/environments/environment';
import { Component, EventEmitter, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TriageMvpTileComponent } from '../../../tiles/triage-mvp-tile/triage-mvp-tile.component';
import { StepsOfAddUserToOneSelectedAccount } from '../../../pages/add-user-stepper-page/enums/steps-of-add-user-to-one-selected-account.enum';
import { ContentUtil } from '../../../../utils/content/content.util';
import {
    AnalyticsCtaType,
    CtaCallUsLinkLocations,
    CtaNames,
} from '../../../../services/adobe-launch/adobe-launch.cta';
import { Store } from '@ngrx/store';
import { updateAddUserStepperSelectedUserType } from '../../../../store/actions/add-user-stepper-flow.action';
import { UserTypeSelection } from '../../../../enums/user-type-selection.enum';
import { GatekeeperService } from 'src/app/services/gatekeeper/gatekeeper.service';
import { Observable } from 'rxjs';
import { GATEKEEPER_TOGGLES } from 'src/common/constants/gatekeeper-toggles';
import { AdobeLaunchService } from '../../../../services/adobe-launch/adobe-launch.service';
import { AdobeAnalyticsEvent } from '../../../../services/adobe-launch/adobe-launch.events';
import {
    AdobeAnalyticsProcessStep,
    AdobeAnalyticsProcessType,
} from '../../../../services/adobe-launch/adobe-launch.process';
import { Content } from 'src/common/interfaces/content.interface';
import { LinkTarget } from '../../../../enums/link-target.enum';
import { AdobePageName } from '../../../../services/adobe-launch/adobe-launch.pages';

@Component({
    selector: 'zci-add-user-triage-page-mvp',
    templateUrl: 'add-user-triage-page-mvp.component.html',
    styleUrls: ['add-user-triage-page-mvp.component.scss'],
    standalone: true,
    imports: [CommonModule, TriageMvpTileComponent],
})
export class AddUserTriagePageMvpComponent implements OnInit {
    private store = inject(Store);
    private readonly gatekeeperService = inject(GatekeeperService);
    private readonly adobeLaunchService = inject(AdobeLaunchService);

    @Input() nextStepClicked: EventEmitter<any>;
    @Input() nextStepReady: EventEmitter<any>;

    @Input() currentStep: StepsOfAddUserToOneSelectedAccount;

    environment = environment;

    grantorWhoGivingAccessContent: Content['frmcWhoGivingAccess'] =
        ContentUtil.content?.frmcWhoGivingAccess;

    location: CtaCallUsLinkLocations = CtaCallUsLinkLocations.ZCI_TRIAGE_PAGE;

    isMVP2Enabled$: Observable<boolean>;

    constructor() {
        this.isMVP2Enabled$ = this.gatekeeperService.isToggleActive(GATEKEEPER_TOGGLES.MVP_TWO_TOGGLE_ENABLED);
    }

    ngOnInit() {
        this.adobeLaunchService.pageLoad(AdobePageName.GAF_TRIAGE);
    }

    navigateSelectUser(isMVP2Enabled: boolean) {
        if (isMVP2Enabled) {
            this.adobeLaunchService.trackAction({
                ctaName: CtaNames.PERSON,
                ctaType: AnalyticsCtaType.LINK,
                location: this.location,
            });
        } else {
            this.adobeLaunchService.trackAction({
                ctaName: CtaNames.ALREADY_HAS_ACCESS_PERMISSIONS,
                ctaType: AnalyticsCtaType.LINK,
                location: this.location,
            });
        }

        this.adobeLaunchService.trackProcess(AdobeAnalyticsEvent.PROCESS_START, {
            processType: AdobeAnalyticsProcessType.GAF_GRANT_ACCESS_FLOW,
            processStep: AdobeAnalyticsProcessStep.GAF_NEXT,
        });

        this.store.dispatch(
            updateAddUserStepperSelectedUserType({ selectedUserType: UserTypeSelection.EXISTING }),
        );

        setTimeout(() => {
            this.nextStepReady.emit(true);
        }, 300);
    }

    navigateAddSomeoneElse() {
        this.store.dispatch(
            updateAddUserStepperSelectedUserType({ selectedUserType: UserTypeSelection.NEW }),
        );
        this.nextStepReady.emit(true);
    }

    navigateToFormFromNonVGUser() {
        window.open(environment.AGENT_AUTHORIZATION_FORM_URL, LinkTarget.Self);
    }

    navigateToFormFromOrgTrust() {
        this.adobeLaunchService.trackAction({
            ctaName: CtaNames.ORGANIZATION_OR_TRUST,
            ctaType: AnalyticsCtaType.LINK,
            location: this.location,
        });

        this.adobeLaunchService.trackProcess(AdobeAnalyticsEvent.PROCESS_START, {
            processType: AdobeAnalyticsProcessType.GAF_LEGACY_GRANT_ACCESS_FLOW,
            processStep: AdobeAnalyticsProcessStep.GAF_NEXT,
        });
        setTimeout(() => {
            window.open(environment.AGENT_AUTHORIZATION_FORM_URL, LinkTarget.Self);
        }, 400);
    }
}
